import { lazy } from 'react';
import i18next from 'i18next';
import { ClaimReportsIcon } from '@shared/ui/icons';
import permissions from '@shared/config/permissions';

const ClaimReports = lazy(() => import('@pages/claim-reports'));

// const CLAIM_REPORT_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/claimReport',
//   exact: true,
//   additional: {
//     component: ClaimReports,
//     protected: true,
//     title: i18next.t('titles:claimReports'),
//     icon: ClaimReportsIcon,
//     permission: permissions.CLAIM_REPORTS_GET,
//   },
// };

const CLAIM_REPORT_ROUTE_LIST = {
  path: '/:currentAccountUuid/claimReport',
  exact: true,
  additional: {
    component: ClaimReports,
    protected: true,
    title: i18next.t('titles:claimReports'),
    icon: ClaimReportsIcon,
    permission: permissions.CLAIM_REPORTS_GET,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.claimReports || 'Claim Reports',
    },
  },
};

export const CLAIM_REPORT_ROUTES = {
  // ------- For child accounts ------
  // listDS: CLAIM_REPORT_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: CLAIM_REPORT_ROUTE_LIST,
};
